import axios from 'axios';
import {signedUserData} from "../../utils/user";

const log = require("loglevel").getLogger("ContactService");
log.setLevel("error");

export const loadContacts = (vendor, limit, offset, withTotal, selectedFilters) => {
	log.debug("ContactService -> loadContacts -> Enter");
	return axios.post(`${process.env.REACT_APP_HOST_URL}/contact/get?withTotal=${withTotal}`, {vendor,limit, offset, selectedFilters})
		.then(async response => {
			log.debug("ContactService -> loadContacts -> return");
			const contacts = response.data.data;
			const total = response.data.total;
			return {contacts, total};
		})
		.catch(response => {
			log.debug("ContactService -> loadContacts -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadContactByVendorAndId = (vendor, id) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/contact/get/id`, {vendor, id})
		.then(async response => {
			const res = response.data.data;
			log.debug("ContactService -> loadContactByVendorAndId -> return");
			return res;
		})
		.catch(response => {
			log.debug("ContactService -> loadContactByVendorAndId -> error: ");
			log.debug(response);
			return null;
		});
};

export const uploadContacts = async (file, vendor) => {
	const formData = new FormData();
	formData.append('file', file);
	formData.append('vendor', vendor);

	try {
		const user = JSON.parse(signedUserData());
		const customHeaders = {
			'Connact-Access': user.uid
		};

		const response = await fetch(`${process.env.REACT_APP_HOST_URL}/contact/upload`, {
			method: 'POST',
			body: formData,
			headers: customHeaders
		});

		if (!response.ok) {
			log.debug("ContactService -> uploadContacts -> error: ");
			log.debug(response);
			return response;
		}

		const data = await response.json();
		log.debug("ContactService -> uploadContacts -> result: ", data);
		return data;
	} catch (error) {
		log.debug("ContactService -> uploadContacts -> error: ");
		log.debug(error);
	}
}
